/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject, Injectable } from '@angular/core';
import { APP_CONSTANTS } from '@shared/core';
import {
    getStatusText,
    InMemoryDbService,
    ParsedRequestUrl,
    RequestInfo,
    RequestInfoUtilities,
    ResponseOptions,
    STATUS,
} from 'angular-in-memory-web-api';
import { InitDb } from './data/init-db';
import { ExampleMock } from './data/mock/example-mock';

const postMethodGetDataRepo = {
    'example/mock': new ExampleMock(),
};

const getMethodGetDataRepo = {
    //example: new ExampleAllMock(),
};

@Injectable({
    providedIn: 'root',
})
export class InMemoryDataService implements InMemoryDbService {
    private db: any;
    private readonly appConstants = inject(APP_CONSTANTS);

    public createDb(reqInfo?: any): any {
        const initialDb = new InitDb().getData(reqInfo);
        this.db = { initialDb };
        return initialDb;
    }

    // HTTP GET interceptor
    get(reqInfo: RequestInfo): any {
        if (Object.getOwnPropertyDescriptor(getMethodGetDataRepo, reqInfo.collectionName)) {
            return this.handleRequest(reqInfo, getMethodGetDataRepo);
        }
        return undefined; // let the default GET handle all others
    }

    // HTTP POST interceptor
    post(reqInfo: RequestInfo): any {
        if (Object.getOwnPropertyDescriptor(postMethodGetDataRepo, reqInfo.collectionName)) {
            return this.handleRequest(reqInfo, postMethodGetDataRepo);
        }
        return undefined; // let the default POST handle all others
    }

    private handleRequest(reqInfo: RequestInfo, dataRepo: any): any {
        return reqInfo.utils.createResponse$(() => {
            const dataEncapsulation = reqInfo.utils.getConfig().dataEncapsulation;
            const data = dataRepo[reqInfo.collectionName].getData(reqInfo, this.db);

            const options: ResponseOptions = data
                ? {
                      body: dataEncapsulation ? { data } : data,
                      status: STATUS.OK,
                  }
                : {
                      body: { error: `'Not found` },
                      status: STATUS.NOT_FOUND,
                  };
            return this.finishOptions(options, reqInfo);
        });
    }

    private finishOptions(options: ResponseOptions, { headers, url }: RequestInfo): any {
        options.statusText = getStatusText(options.status as unknown as number);
        options.headers = headers;
        options.url = url;
        return options;
    }

    // parseRequestUrl override
    // Do this to manipulate the request URL or the parsed result
    // into something your data store can handle.
    // This example turns a request for `/foo/heroes` into just `/heroes`.
    // It leaves other URLs untouched and forwards to the default parser.
    // It also logs the result of the default parser.
    parseRequestUrl(url: string, utils: RequestInfoUtilities): ParsedRequestUrl {
        if (url.endsWith('.json')) {
            return utils.parseRequestUrl(url);
        }

        const splitted = url.split('/');
        const isLastArgumentIsId = Number.isInteger(parseInt(splitted[splitted.length - 1], 10));
        const collectionIndex = isLastArgumentIsId ? splitted.length - 3 : splitted.length - 2;
        const actionIndex = isLastArgumentIsId ? splitted.length - 2 : splitted.length - 1;

        const collectionName = splitted[collectionIndex] + '/' + splitted[actionIndex];

        //   const newUrl = splitted.join('/');
        const parsed = utils.parseRequestUrl(url);
        // const body = utils.getJsonBody(url);
        // parsed.query = new Map<string, string[]>([]); // remove query parameters and work only with URL
        parsed.apiBase = this.appConstants.environment.api.url;
        parsed.collectionName = collectionName;
        parsed.id = isLastArgumentIsId ? (splitted[splitted.length - 1] as any) : '';
        parsed.resourceUrl = parsed.resourceUrl + parsed.collectionName;
        return parsed;
    }
}
